import React, { memo, useEffect, useReducer, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import useDashboardFilterHook from '../Shared/useDashboardFilterHook'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import AmountFormatter from '../../../../utils/AmountFormatter'
import DownloadCSVLink from '../../../../utils/DownloadCSVLink'
import GridColumnHeader from '../../../Setup/Shared/GridColumnHeader'
import Table from '../../../Setup/Shared/Table'
import AreaChart from '../Charts/AreaChart'

const paymentForList = [
  { value: 'System Visits', display: 'System Visits' },
  { value: 'External Visits', display: 'External Visits' },
  { value: 'All', display: 'All' },
]

const API_URL = enumUtil.controller.Dashboard

const PaymentReceived = memo((props) => {
  const { reloadData } = props;

  const [paymentsReceivedData, setPaymentsReceivedData] = useState([]);
  const [paymentsReceivedDataSorting, setPaymentsReceivedDataSorting] = useState([]);
  const [isLoadingPaymentReceived, setIsLoadingPaymentReceived] = useState(false);
  const [activeTab, setActiveTab] = useState('Graph');
  const [reloadChart, setReloadChart] = useState(false);

  const [PaymentForPaymentReceivedDisplay, setPaymentForPaymentReceivedDisplay] = useState('All');

  const [gridHeaderPaymentRec, handleGridHeaderPaymentRec] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' });

  const LoadData = () => {
    setIsLoadingPaymentReceived(true);
    setPaymentsReceivedData([]);

    ServerRequestProtected(API_URL + '/GetPaymentReceivedData', 'post', {
      "TableName": enumUtil.enumAPITableName.Dashboard,
      "SearchParam": "Payment Received",
      ...searchPaymentReceivedFilterModal
    }).then((response) => {
      setPaymentsReceivedData(response);
      setPaymentsReceivedDataSorting(response?.[1]);
      handleGridHeaderPaymentRec({ defaultData: response?.[1] });
      setReloadChart(prev => !prev);
    }).catch(() => {
    }).finally(() => {
      setIsLoadingPaymentReceived(false);
    });
  };

  let [
    setOpenPaymentReceivedFilter,
    searchPaymentReceivedFilterModal,
    paymentReceivedFilterDiv,
    setPaymentsForPaymentReceived,
    paymentsForPaymentReceived,
  ] = useDashboardFilterHook(
    LoadData, 
    'Payment Received', 
    () => {}, 
    null,
    null,
    () => {
      // -- onReset -- //  
      setPaymentForPaymentReceivedDisplay('All');
    }
  );

  useEffect(() => {
    LoadData();
  }, [paymentsForPaymentReceived, reloadData]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === 'PaymentForPaymentReceived') setPaymentForPaymentReceivedDisplay(value);
  };

  const handleSelectedDataa = (selectedData, name, type) => {
    if (type === 'client' && selectedData) {
      if (name === 'PaymentForPaymentReceived') {
        setPaymentsForPaymentReceived(selectedData.value + "");
        setPaymentForPaymentReceivedDisplay(selectedData.display);
        if (selectedData.value !== paymentsForPaymentReceived) setIsLoadingPaymentReceived(true);
      }
    } else {
      if (name === 'PaymentForPaymentReceived') setPaymentForPaymentReceivedDisplay('');
    }
    return selectedData;
  };

  const paymentsReceivedColumns = [
    {
      key: 'MonthStart',
      name: (<GridColumnHeader gridHeader={gridHeaderPaymentRec} handleGridHeader={handleGridHeaderPaymentRec}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Month'} sortIcon={true} type={'string'} colKey={'MonthStart'} data={paymentsReceivedDataSorting} setData={setPaymentsReceivedDataSorting} />),
    },
    {
      key: 'Payment Received',
      name: (<GridColumnHeader gridHeader={gridHeaderPaymentRec} handleGridHeader={handleGridHeaderPaymentRec}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Payment Received'} sortIcon={true} type={'string'} colKey={'Payment Received'} data={paymentsReceivedDataSorting} setData={setPaymentsReceivedDataSorting} />),
      renderCell: ({ row }) => {
        return (<AmountFormatter amount={row?.['Payment Received']} />);
      }
    },
  ];

  return (
    <div className="filter-row border-0 card_tabs p-2 payement-recieved">
      <div className="d-flex justify-content-between align-items-center position-relative za_br_light br-bottom-1 pb-1-5 mb-06-px text-nowrap gap-15">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">Payment Received</p>
          <p className="za-dot text fst-italic fs-11">{paymentsReceivedData?.[2]?.DateRange}</p>
        </div>

        <div className="ar_views d-flex cursor-pointer">
          <p className={`${activeTab === 'Graph' ? 'active' : ''}`} onClick={() => setActiveTab('Graph')}>
            <div className="app_tooltip left w-100 h-100 align-items-center justify-content-center">
              <i className="bi-bar-chart-line ar-light-color fs-16 lh-16"></i>
              <p className="tool_tip xsm_text text-light">Graph View</p>
            </div>
          </p>
          <p className={`${activeTab === 'Grid' ? 'active' : ''}`} onClick={() => setActiveTab('Grid')}>
            <div className="app_tooltip right w-100 h-100 align-items-center justify-content-center">
              <i className="bi bi-grid-3x3 fs-16 lh-16 ar-light-color"></i>
              <p className="tool_tip xsm_text text-light">Grid View</p>
            </div>
          </p>
        </div>

        <span className="ar_dash-filter d-flex align-items-center gap-2">
          {isLoadingPaymentReceived ?
            (<div className="ar-small-loader last_loader">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
            </div>) : <></>}
          <div className="">
            <SuperSearchList
              type="client"
              id='PaymentForPaymentReceived'
              name='PaymentForPaymentReceived'
              searchValue={PaymentForPaymentReceivedDisplay}
              data={paymentForList}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          <div className="app_tooltip left">
            <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenPaymentReceivedFilter(prev => !prev)}></i>
            <p className="tool_tip xsm_text text-light">Filters</p>
          </div>
          {activeTab === 'Grid' ?
            paymentsReceivedData?.[1] &&
            <DownloadCSVLink name={"PaymentsReceivedData.csv"} data={paymentsReceivedData?.[1]} columns={paymentsReceivedColumns} /> : <></>}
        </span>
        {paymentReceivedFilterDiv}
      </div>
      <div>
        {activeTab === 'Graph' ? paymentsReceivedData?.[0]?.[0]?.data ?
          <AreaChart key={reloadChart} data={paymentsReceivedData?.[0]?.[0]?.data} insurancesData={paymentsReceivedData?.[0]?.[0]?.InsuranceDetails?.[0]} PaymentReceivedDateType={searchPaymentReceivedFilterModal.SearchCriteria.Value} /> : <div style={{ height: 180 }}></div>
          :
          activeTab === 'Grid' ?
            <div>
              <Table
                columns={paymentsReceivedColumns}
                dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
                rowHeight={25}
                rows={paymentsReceivedDataSorting || []}
                height='179px'
                hidePagination={true}
                isLoading={true}
                hideColClass={'hide'}
              /></div> : <div style={{ height: 179 }}></div>}
      </div>
    </div>
  );
});

export default PaymentReceived;